import { CommsCheckResult } from '../types/comms-check';
import { createContext, useContext } from 'react';

export enum StandAloneCommsCheckScreenType {
  INITIAL_QUESTIONS,
  COMMS_CHECK,
}

interface StandAloneCommsCheckScreenContextProps {
  screen: StandAloneCommsCheckScreenType;
  setScreen: (screen: StandAloneCommsCheckScreenType) => void;
}

export const StandAloneCommsCheckScreenContext = createContext<StandAloneCommsCheckScreenContextProps>({
  screen: StandAloneCommsCheckScreenType.INITIAL_QUESTIONS,
  setScreen: () => {},
});

export type CommsCheckInputs = {
  mpxn: string;
  msn: string;
  mpxnError: string;
  msnError: string;
};

interface CommsCheckInputsContextProps {
  commsCheckInputs: CommsCheckInputs;
  setCommsCheckInputs: (inputs: CommsCheckInputs) => void;
}

export const commsCheckInputsInitialState: CommsCheckInputs = {
  mpxn: '',
  msn: '',
  mpxnError: '',
  msnError: '',
};

export const CommsCheckInputsContext = createContext<CommsCheckInputsContextProps>({
  commsCheckInputs: commsCheckInputsInitialState,
  setCommsCheckInputs: () => {},
});

export const useCommsCheckInputsContext = (): CommsCheckInputsContextProps => {
  const context = useContext(CommsCheckInputsContext);
  if (!context) {
    throw new Error('useInputsContext must be used within a InputsProvider');
  }
  return context;
};

const commsCheckInitialData: CommsCheckResult = {
  xrinv: {
    data: [],
    address: null,
    state: null,
  },
  xritm: {
    data: [],
    state: null,
    msn: '',
  },
  xrdlg: {
    data: [],
    state: null,
  },
};

export default commsCheckInitialData;

interface CommsCheckContextProps {
  commsCheckResultContext: CommsCheckResult;
  setCommsCheckResultContext: (commsCheckResult: CommsCheckResult) => void;
}

export const CommsCheckContext = createContext<CommsCheckContextProps>({
  commsCheckResultContext: commsCheckInitialData,
  setCommsCheckResultContext: () => {},
});

export const useCommsCheckContext = (): CommsCheckContextProps => {
  const context = useContext(CommsCheckContext);
  if (!context) {
    throw new Error('useCommsCheckContext must be used within a CommsCheckContext Provider');
  }
  return context;
};
